import { Component, OnInit, OnDestroy } from "@angular/core";
import { first } from "rxjs/operators";
import { Subscription } from "rxjs";
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig} from "@angular/material/legacy-dialog";
import { animate, state, style, transition, trigger } from "@angular/animations";
import * as _ from "lodash";

import { AppGlobals } from "../app.globals";
import { HousingService, AuthenticationService, MediaWatcherService, AlertService } from "../_services";
import { IUser } from "../_models";
import { HousingApplicationDialogComponent } from "../housing/application";
import { RoommatesDialogComponent } from "../housing/roommates";
import { ArrivalDialogComponent } from "../housing/arrival";
import { CheckoutDialogComponent } from "../housing/checkout";
import { ConfirmationDialogComponent } from "../_components/confirmationDialog/confirmationDialog.component";

@Component({
    templateUrl: "housing.component.html",
    styleUrls: ["housing.component.css"],
    animations: [
        trigger("detailExpand", [
            state("collapsed", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)"))
        ])
    ]
})

export class HousingComponent implements OnInit, OnDestroy {
    applications = null;
    housingApplications = [];
    housingPrograms = [];
    canAddNewApplication: boolean = false;
    currentHousingStudentApplicationScholasticPeriodIds: number[];
    currentHousingStudentApplicationHousingProgramIds: number[];
    today = new Date();
    isMobile = false;
    mediaWatcherSubscription: Subscription;

    currentUser: IUser;
    currentUserSubscription: Subscription;

    displayedColumns = ["housingStudentApplicationStatusId", "scholasticPeriodDescription", "moveInDate", "moveOutDate", "housingApplicationStepDescription", "dateCreated", "lastUpdatedOn", "dateCompleted", "status", "isWaitlisted", "genderInclusiveHousing", "edit", "payment", "roommates", "agreement", "checkOut", "cancel"]; //, "dateCreated", "dateCompleted"];
    dataSource = this.applications;
    expandedElement: any | null;

    constructor(private housingService: HousingService, private authenticationService: AuthenticationService, public dialog: MatDialog, private mediaWatcherService: MediaWatcherService,
        private alertService: AlertService, private appGlobals: AppGlobals) {

    }

    ngOnInit() {
        this.appGlobals.pageTitleValue = "Housing";

        this.mediaWatcherSubscription = this.mediaWatcherService.isTabletLarge.subscribe(isMobile => {
            this.isMobile = isMobile;

            if (this.isMobile)
                this.displayedColumns = ["scholasticPeriodDescription", "moveInDate", "moveOutDate", "housingApplicationStepDescription", "dateCreated", "lastUpdatedOn", "dateCompleted", "status", "isWaitlisted", "genderInclusiveHousing", "edit", "payment", "roommates", "agreement", "checkOut", "cancel", "additionalDetails"]; //, "dateCreated", "dateCompleted"];
            else
                this.displayedColumns = ["housingStudentApplicationStatusId", "scholasticPeriodDescription", "moveInDate", "moveOutDate", "housingApplicationStepDescription", "dateCreated", "lastUpdatedOn", "dateCompleted", "status", "isWaitlisted", "genderInclusiveHousing", "edit", "payment", "roommates", "agreement", "checkOut", "cancel"]; //, "dateCreated", "dateCompleted"];
        });

        this.today.setHours(0, 0, 0, 0);

        this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
            this.currentUser = user;
        });

        setTimeout(() => {
            this.getApplications();
        }, 0);
    }

    getApplications() {
        if (this.currentUser) {
            this.housingService.getApplications(this.currentUser.id)
                .pipe(first())
                .subscribe(applications => {
                    this.applications = _.orderBy(applications, ["scholasticPeriodStartDate", "dateCreated"], ["desc", "desc"]);

                    this.currentHousingStudentApplicationScholasticPeriodIds = _.map(this.applications.filter(f => !f.housingProgramId), "scholasticPeriodId");
                    this.currentHousingStudentApplicationHousingProgramIds = _.map(this.applications.filter(f => f.housingProgramId), "housingProgramId");

                    this.housingService.getHousingApplications(this.currentHousingStudentApplicationScholasticPeriodIds, this.currentUser.schoolId, this.currentUser.providerId, this.currentUser.funnelId)
                        .pipe(first())
                        .subscribe((housingApplications: any) => {
                            this.housingApplications = housingApplications;

                            this.housingService.getHousingPrograms(this.currentHousingStudentApplicationHousingProgramIds, this.currentUser.schoolId)
                                .pipe(first())
                                .subscribe((housingPrograms: any) => {
                                    this.housingPrograms = housingPrograms;

                                    _.forEach(this.applications, (f: any) => {
                                        if (!f.housingProgramId) {
                                            var housingApplication = (_.find(this.housingApplications, { "scholasticPeriodId": f.scholasticPeriodId })) as any;

                                            if (housingApplication) {
                                                var housingApplicationCheckInDate: any = null;

                                                if (f.isResidentAssistant) {
                                                    housingApplicationCheckInDate = {
                                                        checkInDate: housingApplication.residentAssistantCheckInDate
                                                    };
                                                }

                                                if (!housingApplicationCheckInDate && this.currentUser.providerId)
                                                    housingApplicationCheckInDate = _.minBy(_.filter(housingApplication.housingApplicationCheckInDates, (c: any) => {
                                                        if (c.housingApplicationProviderCheckInDates.length > 0)
                                                            return c;

                                                        return null;
                                                    }), "checkInDate") as any;

                                                if (!housingApplicationCheckInDate && this.currentUser.funnelId)
                                                    housingApplicationCheckInDate = _.minBy(_.filter(housingApplication.housingApplicationCheckInDates, (c: any) => {
                                                        if (c.housingApplicationFunnelCheckInDates.length > 0)
                                                            return c;

                                                        return null;
                                                    }), "checkInDate") as any;

                                                var minCheckInDate = _.minBy(housingApplication.housingApplicationCheckInDates, "checkInDate") as any;

                                                f.moveInDate = housingApplicationCheckInDate ? housingApplicationCheckInDate : minCheckInDate;
                                                f.moveOutDate = f.isResidentAssistant ? housingApplication.residentAssistantCheckOutDate : housingApplication.checkOutDate;
                                                f.applicationDeadline = housingApplication.applicationDeadline;
                                                f.contractDeadline = housingApplication.contractDeadline;
                                                f.canCheckOut = housingApplication.canCheckOut;

                                                let applicationDeadline = new Date(housingApplication.applicationDeadline);
                                                f.isPastApplicationDeadline = new Date(applicationDeadline.setDate(applicationDeadline.getDate() + 1)) <= this.today;

                                                //set allowed roommates
                                                var roommatesException: any = null;

                                                if (this.currentUser.providerId) {
                                                    _.forEach(housingApplication.housingApplicationRoommateExceptions, (e: any) => {
                                                        if (!roommatesException && e.housingApplicationRoommateExceptionProviders.find(x => x.providerId === this.currentUser.providerId))
                                                            roommatesException = e;
                                                    });

                                                    _.forEach(housingApplication.housingApplicationCommunicationExceptions, (e: any) => {
                                                        //placement notice exception
                                                        if (e.communicationId === 2 && e.housingApplicationCommunicationExceptionProviders.find(x => x.providerId === this.currentUser.providerId))
                                                            f.placementNoticeSent = true;

                                                        //welcome letter exception
                                                        if (e.communicationId === 3 && e.housingApplicationCommunicationExceptionProviders.find(x => x.providerId === this.currentUser.providerId))
                                                            f.welcomeLetterSent = true;
                                                    });
                                                }

                                                f.allowedRoommates = roommatesException ? roommatesException.numberOfRoommates : housingApplication.numAllowedRoommates;
                                            }
                                        } else {
                                            //housing program applications
                                            var housingProgram = (_.find(this.housingPrograms, { "id": f.housingProgramId })) as any;

                                            if (housingProgram) {
                                                f.moveInDate = { checkInDate: housingProgram.checkInDate };
                                                f.moveOutDate = housingProgram.checkOutDate;
                                                f.applicationDeadline = housingProgram.applicationDeadline;
                                                f.contractDeadline = housingProgram.contractDeadline;
                                                f.canCheckOut = housingProgram.canCheckOut;
                                                f.allowedRoommates = housingProgram.numAllowedRoommates;
                                                f.isPastApplicationDeadline = new Date(housingProgram.applicationDeadline) <= this.today;
                                            }
                                        }

                                        f.depositPaymentInfo = f.studentHousingPaymentInfo.find(d => d.chargeableItemTypeId === 3) || null;

                                        if (f.depositPaymentInfo)
                                            f.depositPaymentInfo.isOverDue = new Date(f.depositPaymentInfo.paymentDeadline) < this.today;

                                        f.basicHousingPaymentInfo = f.studentHousingPaymentInfo.find(d => d.chargeableItemTypeId === 4 && d.allocatedBuildingAddress) || null;

                                        if (f.basicHousingPaymentInfo)
                                            f.basicHousingPaymentInfo.isOverDue = new Date(f.basicHousingPaymentInfo.paymentDeadline) < this.today;

                                        f.singleUpgradePaymentInfo = f.studentHousingPaymentInfo.find(d => d.chargeableItemTypeId === 5 && d.allocatedBuildingAddress) || null;

                                        if (f.singleUpgradePaymentInfo)
                                            f.singleUpgradePaymentInfo.isOverDue = new Date(f.singleUpgradePaymentInfo.paymentDeadline) < this.today;

                                        f.paymentRequired = (f.depositPaymentInfo && f.depositPaymentInfo.payeeId === 2 && !f.depositPaymentInfo.paidAmount)
                                            || (f.basicHousingPaymentInfo && f.basicHousingPaymentInfo.roomTypeId === 2 && f.basicHousingPaymentInfo.payeeId === 2 && (!f.basicHousingPaymentInfo.paidAmount || f.basicHousingPaymentInfo.paidAmount < f.basicHousingPaymentInfo.amount - (f.depositPaymentInfo.payeeId === 2 ? f.depositPaymentInfo.amount : 0)))
                                            || (f.singleUpgradePaymentInfo && f.singleUpgradePaymentInfo.roomTypeId === 1 && f.singleUpgradePaymentInfo.payeeId === 2 && f.basicHousingPaymentInfo && f.basicHousingPaymentInfo.payeeId === 2 && (!f.singleUpgradePaymentInfo.paidAmount || f.singleUpgradePaymentInfo.paidAmount < f.singleUpgradePaymentInfo.amount - (f.depositPaymentInfo.payeeId === 2 ? f.depositPaymentInfo.amount : 0)))
                                            || (f.singleUpgradePaymentInfo && f.singleUpgradePaymentInfo.roomTypeId === 1 && f.singleUpgradePaymentInfo.payeeId === 2 && f.basicHousingPaymentInfo && f.basicHousingPaymentInfo.payeeId === 1 && (!f.singleUpgradePaymentInfo.paidAmount || f.singleUpgradePaymentInfo.paidAmount < f.singleUpgradePaymentInfo.amount - f.basicHousingPaymentInfo.amount - (f.depositPaymentInfo.payeeId === 2 ? f.depositPaymentInfo.amount : 0)));

                                        var pendingRoommateRequests = null;
                                        var acceptedRoommateRequests = null;
                                        var deletedRoommateRequests = null;

                                        if (f.housingStudentApplicationRoommateRequests && f.housingStudentApplicationRoommateRequests.length > 0) {
                                            pendingRoommateRequests = _.filter(f.housingStudentApplicationRoommateRequests, (r: any) => {
                                                return (r.roommateHousingStudentApplicationId === f.id) && (r.housingApplicationRoommateRequestStatusId === 3);
                                            });

                                            acceptedRoommateRequests = _.filter(f.housingStudentApplicationRoommateRequests, (r: any) => {
                                                return r.housingApplicationRoommateRequestStatusId === 1;
                                            });

                                            deletedRoommateRequests = _.filter(f.housingStudentApplicationRoommateRequests, (r: any) => {
                                                return r.housingApplicationRoommateRequestStatusId === 2 && r.lastUpdatedByHousingStudentApplicationId !== f.id && !r.cancelledRequestVerifiedByUser;
                                            });
                                        }

                                        f.pendingRoommateRequests = pendingRoommateRequests && acceptedRoommateRequests && acceptedRoommateRequests.length < f.allowedRoommates ? pendingRoommateRequests.length + (deletedRoommateRequests ? deletedRoommateRequests.length : 0) : 0;
                                        f.deletedRoommateRequests = deletedRoommateRequests;

                                        //if (f.housingStudentApplicationStatusId === 3)
                                        //    this.displayedColumns = ["scholasticPeriodDescription", "moveInDate", "moveOutDate", "housingApplicationStepDescription", "dateCreated", "lastUpdatedOn", "dateCompleted", "status", "edit", "payment", "roommates", "agreement", "checkOut"];
                                    });

                                    let programScholasticPeriodIds = [];

                                    //registered for a housing program
                                    if (this.currentUser.hasValidProgramCode || this.currentUser.hasProgramCodeWithRequiredAdmissions || this.currentUser.hasAdmissionsForProgram) {
                                        const availableHousingPrograms = _.map(_.filter(this.housingPrograms, f => { return /*f.isActive &&*/ f.schoolId === this.currentUser.schoolId && ((this.currentUser.hasValidProgramCode && this.currentUser.programCodes.indexOf(f.code) !== -1) || (this.currentUser.hasProgramCodeWithRequiredAdmissions && f.providerId === this.currentUser.providerId) || (this.currentUser.hasAdmissionsForProgram && f.isOpenForAdmissions)); }) as any, "id");

                                        const difHousingPrograms = _.difference(availableHousingPrograms, this.currentHousingStudentApplicationHousingProgramIds);

                                        this.canAddNewApplication = difHousingPrograms.length > 0;

                                        //get scholastic period ids for programs other then the current ones
                                        programScholasticPeriodIds = _.map(_.filter(this.housingPrograms, f => difHousingPrograms.indexOf(f.id) !== -1), "scholasticPeriodId");

                                        //add scholastic period ids for current programs
                                        _.forEach(this.housingPrograms.filter(f => this.currentHousingStudentApplicationHousingProgramIds.indexOf(f.id) !== -1), p => {
                                            if (programScholasticPeriodIds.indexOf(p.scholasticPeriodId) === -1)
                                                programScholasticPeriodIds.push(p.scholasticPeriodId);
                                        });
                                    }

                                    //only current students can apply for housing, ie once accepted by admissions
                                    if (this.currentUser.studentId && !this.canAddNewApplication /*&& !this.currentUser.hasProgramCodeWithRequiredAdmissions && !this.currentUser.hasValidProgramCode*/) {
                                        const availableScholasticPeriods = _.map(_.filter(this.housingApplications, f => { return f.isActive && f.scholasticPeriod.schoolId === this.currentUser.schoolId && (!this.currentUser.admissionsStartDate || f.scholasticPeriod.startDate >= this.currentUser.admissionsStartDate); }) as any, "scholasticPeriodId");

                                        let difScholasticPeriods = _.difference(availableScholasticPeriods, this.currentHousingStudentApplicationScholasticPeriodIds);

                                        if (programScholasticPeriodIds.length > 0)
                                            difScholasticPeriods = _.difference(difScholasticPeriods, programScholasticPeriodIds);

                                        this.canAddNewApplication = difScholasticPeriods.length > 0;
                                    }
                                });
                        });
                });
        }
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.currentUserSubscription.unsubscribe();
        this.mediaWatcherSubscription.unsubscribe();
    }

    insertOrUpdateApplication(allowEdit: boolean, isSubmitted: boolean, applicationId?: number, selectedStepIndex?: number) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = this.isMobile ? "90%" : "50%";
        dialogConfig.height = "auto";
        dialogConfig.panelClass = "popup-dialog-container";

        const existingApplicationScholasticPeriods = _.map(this.applications.filter(f => !f.housingProgramId), "scholasticPeriodId");
        const existingApplicationHousingPrograms = _.map(this.applications.filter(f => f.housingProgramId), "housingProgramId");

        const isHousingProgramApplication = this.currentUser.hasValidProgramCode || this.currentUser.hasProgramCodeWithRequiredAdmissions || this.currentUser.hasAdmissionsForProgram;

        dialogConfig.data = {
            currentUser: this.currentUser,
            applicationId: applicationId ? applicationId : 0,
            selectedStepIndex: selectedStepIndex ? selectedStepIndex : 0,
            housingApplications: this.housingApplications,
            housingPrograms: this.housingPrograms,
            existingApplicationScholasticPeriods: existingApplicationScholasticPeriods,
            existingApplicationHousingPrograms: existingApplicationHousingPrograms,
            isHousingProgramApplication: isHousingProgramApplication,
            allowEdit: allowEdit,
            isSubmitted: isSubmitted
        };

        const dialogRef = this.dialog.open(HousingApplicationDialogComponent, dialogConfig);

        if (allowEdit) {
            dialogRef.afterClosed().subscribe(() => {
                setTimeout(() => {
                    this.getApplications();
                }, 500);
            });
        }
    }

    roommates(allowEdit: boolean, allowedRoommates: number, housingStudentApplicationId: number, allocationPeriod: string, scholasticPeriodId: any, deletedRoommateRequests: number, housingProgramId?: any) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = this.isMobile ? "90%" : "65%";
        dialogConfig.height = "auto";
        dialogConfig.panelClass = "popup-dialog-container";

        let housingApplication = null;
        let housingProgram = null;

        if (!housingProgramId)
            housingApplication = (_.find(this.housingApplications, { "scholasticPeriodId": scholasticPeriodId })) as any;
        else
            housingProgram = this.housingPrograms.find(f => f.id === housingProgramId) as any;

        dialogConfig.data = {
            currentUser: this.currentUser,
            housingStudentApplicationId: housingStudentApplicationId,
            allowedRoommates: allowedRoommates,
            allocationPeriod: allocationPeriod,
            scholasticPeriodId: scholasticPeriodId,
            housingProgramId: housingProgramId,
            allowEdit: allowEdit,
            defaultAllowedRoommates: housingApplication ? housingApplication.numAllowedRoommates : housingProgram ? housingProgram.numAllowedRoommates : 1,
            deletedRoommateRequests: deletedRoommateRequests
        };

        const dialogRef = this.dialog.open(RoommatesDialogComponent, dialogConfig);

        if (allowEdit) {
            dialogRef.afterClosed().subscribe(val => {
                if (val)
                    setTimeout(() => {
                        this.getApplications();
                    }, 500);
            });
        }
    }

    agreement(allowEdit: boolean, housingStudentApplicationId: number, allocationPeriod: string, scholasticPeriodId: any, defaultMoveInDate: any, moveOutDate: any, housingProgramId?: any) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = this.isMobile ? "90%" : "50%";
        dialogConfig.height = "auto";
        dialogConfig.panelClass = "popup-dialog-container";

        let housingApplicationCheckInDates = [];
        let housingApplication = null;
        let housingProgram = null;

        if (!housingProgramId) {
            housingApplication = (_.find(this.housingApplications, { "scholasticPeriodId": scholasticPeriodId })) as any;

            if (this.currentUser.providerId)
                housingApplicationCheckInDates = _.filter(housingApplication.housingApplicationCheckInDates, (c: any) => {
                    if (c.housingApplicationProviderCheckInDates.length > 0)
                        return c;

                    return null;
                });

            if ((!housingApplicationCheckInDates || housingApplicationCheckInDates.length === 0) && this.currentUser.funnelId)
                housingApplicationCheckInDates = _.filter(housingApplication.housingApplicationCheckInDates, (c: any) => {
                    if (c.housingApplicationFunnelCheckInDates.length > 0)
                        return c;

                    return null;
                });

            if (!housingApplicationCheckInDates || housingApplicationCheckInDates.length === 0)
                housingApplicationCheckInDates = housingApplication.housingApplicationCheckInDates;
        } else {
            housingProgram = this.housingPrograms.find(f => f.id === housingProgramId) as any;

            const checkInDate = {
                id: 1,
                checkInDate: housingProgram.checkInDate
            };

            housingApplicationCheckInDates.push(checkInDate);
        }

        dialogConfig.data = {
            currentUser: this.currentUser,
            housingStudentApplicationId: housingStudentApplicationId,
            allocationPeriod: allocationPeriod,
            //scholasticPeriodId: scholasticPeriodId,
            //housingProgramId: housingProgramId,
            defaultMoveInDate: defaultMoveInDate,
            moveOutDate: moveOutDate,
            checkInDates: housingApplicationCheckInDates,
            checkInLocations: housingProgram ? housingProgram.housingProgramCheckInLocations : housingApplication?.housingApplicationCheckInLocations,
            allowEdit: allowEdit
        };

        const dialogRef = this.dialog.open(ArrivalDialogComponent, dialogConfig);

        if (allowEdit) {
            dialogRef.afterClosed().subscribe(val => {
                if (val)
                    setTimeout(() => {
                        this.getApplications();
                    }, 500);
            });
        }
    }

    checkOut(housingStudentApplicationId: number, allocationPeriod: string, scholasticPeriodId: any, keyCode: string, allocationPeriodStartDate: any, basicHousingPaymentInfo: any, singleUpgradePaymentInfo: any, moveOutDate: Date, housingProgramId?: any) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.closeOnNavigation = true;
        dialogConfig.width = this.isMobile ? "90%" : "50%";
        dialogConfig.height = "auto";
        dialogConfig.panelClass = "popup-dialog-container";

        let nextHousingStudentApplication = null;
        let nextSemesterBuildingName = null;
        let minCheckInDate = null;

        if (!housingProgramId) {
            nextHousingStudentApplication = (_.find(_.orderBy(this.applications, ["allocationPeriodStartDate"], ["asc"]), f => {
                return f.scholasticPeriodStartDate > allocationPeriodStartDate;
            })) as any;

            if (nextHousingStudentApplication) {
                const basicHousingPaymentInfo = nextHousingStudentApplication.studentHousingPaymentInfo.find(d => d.chargeableItemTypeId === 4) || null;

                if (basicHousingPaymentInfo && basicHousingPaymentInfo.allocatedBuildingName) {
                    nextSemesterBuildingName = basicHousingPaymentInfo.allocatedBuildingName;
                }

                if (!nextSemesterBuildingName) {
                    const singleUpgradePaymentInfo = nextHousingStudentApplication.studentHousingPaymentInfo.find(d => d.chargeableItemTypeId === 5) || null;

                    if (singleUpgradePaymentInfo) {
                        nextSemesterBuildingName = singleUpgradePaymentInfo.allocatedBuildingName;
                    }
                }
            }

            const housingApplication = (_.find(this.housingApplications, { "scholasticPeriodId": scholasticPeriodId })) as any;

            minCheckInDate = _.minBy(housingApplication.housingApplicationCheckInDates, "checkInDate") as any;
        } else {
            const housingProgram = this.housingPrograms.find(f => f.id === housingProgramId) as any;

            minCheckInDate = housingProgram.checkInDate;
        }

        dialogConfig.data = {
            currentUser: this.currentUser,
            housingStudentApplicationId: housingStudentApplicationId,
            allocationPeriod: allocationPeriod,
            housingProgramId: housingProgramId,
            moveOutDate: moveOutDate,
            moveInDate: minCheckInDate.checkInDate,
            allowEdit: true,
            keyCode: keyCode,
            nextSemesterBuildingName: nextSemesterBuildingName,
            nextSemesterKeyCode: nextHousingStudentApplication ? nextHousingStudentApplication.keyCode : null,
            displayIndividualBuildings: basicHousingPaymentInfo && basicHousingPaymentInfo.roomTypeId === 2 ? basicHousingPaymentInfo.displayIndividualBuildings : singleUpgradePaymentInfo.displayIndividualBuildings,
            isRecurring: nextHousingStudentApplication ? nextHousingStudentApplication.isRecurring : false
        };

        const dialogRef = this.dialog.open(CheckoutDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(val => {
            if (val)
                setTimeout(() => {
                    this.getApplications();
                }, 500);
        });
    }

    cancelApplication(housingStudentApplicationId: number, housingStudentApplicationStatusId: number, isPastApplicationDeadline: boolean, allocationPeriodDescription: string, rowversion: any) {
        //only apps which are not already rejected or marked as early leaver can be deleted
        if (!isPastApplicationDeadline && (housingStudentApplicationStatusId === 1 || housingStudentApplicationStatusId === 2 || housingStudentApplicationStatusId === 4)) {
            const dialogConfig = new MatDialogConfig();

            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.closeOnNavigation = true;
            dialogConfig.width = this.isMobile ? "80%" : "35%";
            dialogConfig.height = "auto";
            dialogConfig.panelClass = "confirmation-dialog-container";
            dialogConfig.data =
            {
                title: "Cancel Housing Application",
                content: `Housing Application for ${allocationPeriodDescription} will be cancelled.</br></br> Once you cancel your application, you will not be able to reactivate it from the student portal. Please contact <a href='mailto:housing@johncabot.edu' target='_blank'>housing@johncabot.edu</a> for further assistance. </br></br>If you need to edit your application, please submit all changes by the application deadline. After the deadline, your application will remain available to view only.’`,
                rejectedReason: null,
                required: false,
                showSendRejectedEmail: false,
                rejectedEmailText: null
            };

            const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);

            dialogRef.afterClosed().subscribe(result => {
                if (result === "confirm") {
                    const saveModel = {
                        housingStudentApplicationId: housingStudentApplicationId,
                        rowversion: rowversion
                    }

                    this.housingService.cancelHousingStudentApplication(saveModel)
                        .pipe(first())
                        .subscribe(() => {
                            this.alertService.showMessage("Application Cancelled Successfully.", "Housing Applications", this.appGlobals.alertMessageTypes.success);

                            setTimeout(() => {
                                this.getApplications();
                            }, 500);
                        });
                }
            });
        }
    }

    pendingApplicationExists() {
        const app = _.find(this.applications, f => {
            return f.housingStudentApplicationStatusId === 1; //new applications
        });

        return app !== null && app !== undefined;
    }
}